import {Link, redirect, useLoaderData, useParams} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import Cookies from "js-cookie";
import BackButton from "../../components/BackButton";

const TournamentDetails = () => {
    const tournament = useLoaderData();
    const contests = tournament.details.find(item => {
        return item.type === 'regulations';
    }).contests
    const params = useParams();
    return <div>
        <BackButton src={`/tournament/${params.id}`}/>
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px]  mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    <img src="/icons/description-icon.png" className="inline me-3 w-[25px] h-[25px]"/>
                    شرح مسابقات
                </div>
            </div>
        </div>
        <div className="flex items-center mt-2">
            <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <Link to={`/tournament/${params.id}/step/scientific-contest`}
                    className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <span className="text-[18px]">مسابقه علمی</span>
                </Link>
                {contests.map((c, index) => {
                    return <Link to={`/tournament/${params.id}/step/${c.id}`} key={index}
                                 className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                        <span className="text-[18px]">{c.name}</span>
                    </Link>
                })}
            </div>
        </div>
    </div>
}

export default TournamentDetails

export async function TournamentDetailsPageLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/user/tournament/${params.id}/steps`, (res) => {
                data = res.data.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}